import React from 'react';
import PropTypes from 'prop-types';

import contractPage from 'hoc/contractPage/contractPage';

import ContractTemplate from '../patterns/ContractTemplate/ContractTemplate';

export function NuConta({ pageContent }) {
  return (
    <ContractTemplate title="Contrato da Conta do Nubank">
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: pageContent }} />
    </ContractTemplate>
  );
}

NuConta.propTypes = {
  pageContent: PropTypes.string.isRequired,
};

export default contractPage(NuConta, {
  routeKey: 'NUCONTA_CONTRACT',
  googleDocumentId: '1tc7RqSr6xzrRptRKTYRK-FB9zq2hsFSUpEs1pdzMDQU',
});
